import React, { Component } from 'react'

import { logoutUser } from '../../actions/auth'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withRouter } from 'react-router-dom'


class Logout extends Component {
  componentDidMount() {
    this.props.actions.logoutUser()
  }

  render() {
    const { isFetching, isAuthenticated } = this.props
    if (!isFetching && !isAuthenticated) {
      return (
                <div>
                    You have successfully logged out, redirecting you...
                </div>
      )
    } else {
      return (
                <div>
                    logging out...
                </div>
      )
    }
  };
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ logoutUser }, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout))
